import React from 'react'

import { motion } from 'framer-motion'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/ui/tooltip'


const MotionTooltipContent = motion.create(
  React.forwardRef((props: any, ref) => (
    <TooltipContent ref={ref} {...props} />
  ))
)

export const LevelTooltipContent = () => {
  return (
    <Tooltip open>
      <TooltipTrigger asChild>
        <div className="absolute top-0 w-full h-full mt-3" />
      </TooltipTrigger>

      <MotionTooltipContent
        className="font-sans bg-jacaranda text-white shadow-lg **:data-radix-tooltip-arrow:fill-jacaranda **:data-radix-tooltip-arrow:bg-jacaranda"
        side="top"
        animate={{ y: [0, -10, 0] }}
        transition={{
          repeat: Infinity,
          duration: 1.3,
          ease: 'easeInOut'
        }}
      >
        <span className="text-white text-lg">Começar</span>
      </MotionTooltipContent>
    </Tooltip>
  )
}
